import { jsxs as c, jsx as r } from "react/jsx-runtime";
import o from "./Alert.module.css.js";
import { IconButton as f } from "../IconButton/IconButton.js";
import { Close as p } from "../../foundations/icons/Close.js";
import { Sparkle as d } from "../../foundations/icons/Sparkle.js";
import { ErrorIcon as u } from "../../foundations/icons/Error.js";
import { Warning as C } from "../../foundations/icons/Warning.js";
import { Info as I } from "../../foundations/icons/Info.js";
import { Success as N } from "../../foundations/icons/Success.js";
const $ = {
  success: /* @__PURE__ */ r(N, {}),
  info: /* @__PURE__ */ r(I, {}),
  warning: /* @__PURE__ */ r(C, {}),
  error: /* @__PURE__ */ r(u, {}),
  ai: /* @__PURE__ */ r(d, {})
}, S = ({
  status: n = "warning",
  onClose: e,
  children: t,
  withStartAdornmentIcon: i = !1,
  customAdornmentIcon: l = null,
  className: m = "",
  iconButtonProps: a = {},
  ...s
}) => /* @__PURE__ */ c(
  "div",
  {
    className: `${o.alertContainer} ${o[`${n}Container`]} ${m}`,
    ...s,
    children: [
      i ? /* @__PURE__ */ r("div", { className: o.adornmentIconContainer, children: l ?? $[n] }) : null,
      /* @__PURE__ */ r("div", { className: o.alertContent, children: t }),
      e ? /* @__PURE__ */ r(
        f,
        {
          ariaLabel: "Close",
          onClick: e,
          className: o.closeButton,
          ...a,
          children: /* @__PURE__ */ r(p, {})
        }
      ) : null
    ]
  }
);
export {
  S as Alert
};
//# sourceMappingURL=Alert.js.map
